import axios from "axios";

const LIS_API_KEY = process.env.REACT_APP_LIS_API_KEY;
const isDirect = !!LIS_API_KEY;

const LIS_BASE = isDirect
  ? process.env.REACT_APP_LIS_API_URL
  : "";

// id_module por modelo (sólo se usa en modo directo a APIM)
const MODULE_IDS = {
  normativo: process.env.REACT_APP_LIS_MODULE_ID,
  juridico: process.env.REACT_APP_LIS_MODULE_ID_JURIDICO,
};

const resolveModuleId = (modelo) => MODULE_IDS[modelo] || MODULE_IDS.normativo;

const directFetch = async (url, options = {}) => {
  const res = await fetch(url, {
    ...options,
    headers: {
      "API-KEY": LIS_API_KEY,
      ...options.headers,
    },
  });
  if (!res.ok) throw new Error(`LIS API error: ${res.status}`);
  return res.json();
};

export const createChat = async (email, modelo = "normativo") => {
  if (isDirect) {
    const moduleId = resolveModuleId(modelo);
    return directFetch(
      `${LIS_BASE}/latest/chat/?id_module=${moduleId}&email=${encodeURIComponent(email)}`,
      { method: "POST" }
    );
  }
  const res = await axios.post("legalia/chat/create", { email, modelo });
  return res.data;
};

export const sendMessage = async (chatId, question, email, modelo = "normativo") => {
  if (isDirect) {
    return directFetch(
      `${LIS_BASE}/latest/chat/respond/${chatId}?question=${encodeURIComponent(question)}`,
      { method: "POST" }
    );
  }
  const res = await axios.post(`legalia/chat/respond/${chatId}`, { question, email, modelo });
  return res.data;
};

export const listChats = async (email, modelo = "normativo") => {
  if (isDirect) {
    const moduleId = resolveModuleId(modelo);
    return directFetch(
      `${LIS_BASE}/latest/chat/list?id_module=${encodeURIComponent(moduleId)}&email=${encodeURIComponent(email)}`
    );
  }
  const res = await axios.get("legalia/chat/list", { params: { email, modelo } });
  return res.data;
};

export const getChatRecord = async (chatId, email) => {
  if (isDirect) {
    return directFetch(`${LIS_BASE}/latest/chat/record/${chatId}`);
  }
  const res = await axios.get(`legalia/chat/record/${chatId}`);
  return res.data;
};

export const sendFeedback = async (interactionId, feedback, comment = "") => {
  const body = {
    like: feedback === "like",
    dislike: feedback === "dislike",
    comment: comment || "",
  };
  if (isDirect) {
    return directFetch(
      `${LIS_BASE}/latest/chat/feedback/${interactionId}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }
    );
  }
  const res = await axios.post(`legalia/chat/feedback/${interactionId}`, body);
  return res.data;
};
